import axios from 'axios';
import config from '../../config';
const baseUrl = config.baseUrl;



export const getZonasInfluencia = async () => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/zonas-influencia`
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo zonas de influencia'
        };
    }
};

export const getTiposZonaInfluencia = async () => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/tipos-zona-influencia`
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo tipos zona influencia'
        };
    }
};

export const getDepartamentos = async () => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/zonas-influencia-departamentos`
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo departamentos'
        };
    }
};

export const getMunicipios = async (
    oidDepartamento
) => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/zonas-influencia-municipios/${oidDepartamento}`
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message: 'Error obteniendo municipios'
        };
    }
};

export const createZonaInfluencia = async (
    payload
) => {
    try {
        const response = await axios.post(
            `${baseUrl}/api/zonas-influencia`,
            payload
        );
        return {
            status: response.status,
            data: response.data
        };
    } catch (error) {
        return {
            status: error.response?.status || 500,
            message:
                error.response?.data?.message ||
                'Error creando zona influencia'
        };
    }
};